/*eslint-disable */
var $ = window.jQuery = require('jquery');

import Router from 'vue-router'
import Vue from 'vue'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  //  const router {
  mode: 'history',
  canReuse: false,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [{
      path: '*',
      redirectTo: '/'
    },
    {
      path: '/',
      name: 'home',
      component: () => import( /* webpackChunkName: "home" */ './view/home/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega',
          next();
      }
    },
    {
      path: '/testimonials',
      name: 'testimonials',
      component: () => import( /* webpackChunkName: "testimonials" */ './view/testimonials/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Testimonials'
        next();
      }
    },
    {
      path: '/media/',
      name: 'media',
      component: () => import( /* webpackChunkName: "media" */ './view/media/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Media'
        next();
      }
    },
    {
      path: '/about-us/',
      name: 'AboutUs',
      component: () => import( /* webpackChunkName: "media" */ './view//about-us/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - About Us'
        next();
      }
    },    
    {
      path: '/user/agreement/',
      name: 'userAgreement',
      component: () => import( /* webpackChunkName: "userAgreement" */ './view/user-agreement/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - User Agreement',
        next();
      }
    },
    {
      path: '/contact-us/',
      name: 'ContactUs',
      component: () => import( /* webpackChunkName: "media" */ './view//contact-us/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Contact Us'
        next();
      }
    },
    {
      path: '/help/',
      name: 'help',
      component: () => import( /* webpackChunkName: "help" */ './view/help-support-form/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Help'
        next();
      }
    },
    {
      path: '/media/details/:mediaId',
      name: 'mediaDetails',
      component: () => import( /* webpackChunkName: "media" */ './view/media-details/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Media Details'
        next();
      }
    },
    {
      path: '/privacy-policy/',
      name: 'PrivacyPolicy',
      component: () => import( /* webpackChunkName: "courseDetail" */ './view/privacy-policy/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Privacy Policy'
        next();
      }
    },
    {
      path: '/terms-of-condition/',
      name: 'termsOfCondition',
      component: () => import( /* webpackChunkName: "courseDetail" */ './view/terms-of-condition/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Terms Of Condition'
        next();
      }
    },
    {
      path: '/course/:slug/',
      name: 'course-category',
      component: () => import( /* webpackChunkName: "courseCategory" */ './view/courseCategory/index.vue'),
    },
    {
      path: '/course/:category/:slug/',
      name: 'coursedescription',
      component: () => import( /* webpackChunkName: "publicCourseDescription" */ './view/publicCourseDescription/index.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import( /* webpackChunkName: "login" */ './view/login/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Login'
        next();
      }
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import( /* webpackChunkName: "register" */ './view/register/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Signup'
        next();
      }
    },
    {
      path: '/account/reset-password/',
      name: 'forgotPassword',
      component: () => import( /* webpackChunkName: "forgotPassword" */ './view/forgot-password/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Password Reset'
        next();
      }
    },
    {
      path: '/account/reset-password/:reset_key',
      name: 'passwordReset',
      component: () => import( /* webpackChunkName: "passwordChanged" */ './view/password-reset/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Password Reset'
        next();
      }
    },
    {
      path: '/account/verify/:id',
      name: 'userVerified',
      component: () => import( /*webpackChunkName: "userVerified" */ './view/user-verify/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - User Verify'
        next();
      }
    },
    {
      path: '/dashboard',
      component: () => import( /* webpackChunkName: "userDashboard" */ './view/user-dashboard/index.vue'),
      beforeEnter: (to, from, next) => {
        next();
      },
      children: [
        {
          path: '/profile/',
          name: 'profile',
          component: () => import( /* webpackChunkName: "userProfile" */ './view/user-profile/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('EnrolledCourseByNumber').then((res) => {
              $('.httploader').hide()
            }).catch((err) => {});
            store.dispatch('getAssignmentByNumber').then((res) => {
              $('.httploader').hide()
            })
            store.dispatch('getProfile').then((res) => {
              $('.httploader').hide()
            })
            store.dispatch('getUserAttemptQuizHistoriesList').then((res) => {
            $('.httploader').hide()
            })
            store.dispatch('getContestPointsObtainedFun')
            document.title = 'Oddvega - Profile'
            next();
          }
        },
        {
          path: '/update-profile/',
          name: 'update-profile',
          component: () => import( /* webpackChunkName: "updateUserProfile" */ './view/updateUserProfile/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Update Profile'
            next();
          }
        },
        {
          path: '/update-profile/:quizError',
          name: 'update-profile-edit',
          component: () => import( /* webpackChunkName: "updateUserProfile" */ './view/updateUserProfile/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Update Profile'
            next();
          }
        },
        {
          path: '/assignment/',
          name: 'assignment',
          component: () => import( /* webpackChunkName: "assignement" */ './view/assignment/index.vue'),
          beforeEnter: (to, from, next) => {
            // Get Assignment
            store.dispatch('getAssignmentActn').then((res) => {
              $('.httploader').hide()
            }).catch((err) => {

            })

            document.title = 'Oddvega - Assignment'
            next();
          }
        },
        {
          path: '/courses/',
          name: 'usercourses',
          component: () => import( /* webpackChunkName: "courseList" */ './view/course-list/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getProfile').then((res) => {
              store.dispatch('getCategoryListActn').then((res) => {
              store.dispatch('getcourselist')
              .then((res) => {
                $('.httploader').hide()
              })
              });
            }).catch((err) => {});
            document.title = 'Oddvega - Courses'
            next();
          }
        },
        {
          path: '/courses/category/:id',
          name: 'usercourses-category',
          component: () => import( /* webpackChunkName: "coursesBycategory" */ './view/coursesBycategory/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getCategoryListActn').then((res) => {
            });
            store.dispatch('getProfile').then((res) => {
              $('.httploader').hide()
            })
            document.title = 'Oddvega - Courses'
            next();
          }
        },
        {
          path: '/courses/:courseid',
          name: 'coursesdescription',
          component: () => import( /* webpackChunkName: "courseDetail" */ './view/coursedetail/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            // store.dispatch('getSingleCourseDetail', {
            //   courseid: to.params.courseid
            // }).then((res) => {
            //   // console.log(error.status, 'Course Details Data')
            // })
            document.title = 'Oddvega - Course'
            next();
          }
        },
        {
          path: '/interview/courses/:courseid',
          name: 'interViewCourseDetails',
          component: () => import( /* webpackChunkName: "courseDetail" */ './view/interview-course-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
              // store.dispatch('getInterviewCourseDetails', {
              //   id: to.params.courseid
              // }).then((res) => {
              // })
            document.title = 'Oddvega - Course'
            next();
          }
        },

        {
          path: '/courses/:courseid/quiz/:quizId',
          name: 'coursesquiz',
          component: () => import( /* webpackChunkName: "courseQuiz" */ './view/coursequiz/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Course Quiz'
            next();
          }
        },

        {
          path: '/favourites/',
          name: 'my-favourites',
          component: () => import( /* webpackChunkName: "myCourses" */ './view/mycourse/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getCategoryListActn').then((res) => {
            });
            store.dispatch('getEnrolledCoursesActn').then((res) => {
              $('.httploader').hide()
            });
            document.title = 'Oddvega - Favourites'
            next();
          }
        },
        {
          path: '/userquizes/history/:courseId',
          name: 'quizHistory',
          component: () => import( /* webpackChunkName: "userQuiz" */ './view/userquiz/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Quiz History'
            next();
          }
        },
        {
          path: '/category/:id',
          name: 'courseByCategory',
          component: () => import( /* webpackChunkName: "categoryProject" */ './view/categoryproject/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('CourseByCategoryAction', {
              id: to.params.id
            }).then((res) => {

            })
            document.title = 'Oddvega - Category'
            next();
          },
          beforeRouteUpdate: (to, from, next) => {

          }
        },

        {
          path: '/assignment/:id',
          name: 'assignment-description',
          component: () => import( /* webpackChunkName: "assignmentbrief" */ './view/assignmentbrief/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSignleAssignmentActn', {
              id: to.params.id
            }).then((res) => {
              $('.httploader').hide()
            }).catch((err) => {

            })
            document.title = 'Oddvega - Assignment'
            next();
          }
        },
        {
          path: '/upload-solution/',
          name: 'upload-solution',
          component: () => import( /* webpackChunkName: "uploadsolution" */ './view/uploadsolution/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Upload Solution'
            next();
          }
        },
        {
          path: '/courses/search/result/:searchkeyword/',
          name: 'result',
          component: () => import( /* webpackChunkName: "searchresult" */ './view/searchresult/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Result'
            next();
          }
        },
        {
          path: '/payment/',
          name: 'paypalPayment',
          component: () => import( /* webpackChunkName: "paypalPayment" */ './view/paypalPayment/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Payment'
            next();
          }
        },
        {
          path: '/payment/confirm/',
          name: 'paymentConfirmation',
          component: () => import( /* webpackChunkName: "paymentConfirmation" */ './view/payment-confirmation/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Payment Confirmation'
            next();
          }
        },
        {
          path: '/payment/history/',
          name: 'paymentHistory',
          component: () => import( /* webpackChunkName: "paymentHistory" */ './view/paymentHistory/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getPaymnetHistories').then((res) => {
              $('.httploader').hide()
            }).catch((err) => {})
            document.title = 'Oddvega - Payment History'
            next();
          }
        },
        // {
        //   path: '/contest/old/',
        //   name: 'contest',
        //   component: () => import( /* webpackChunkName: "paymentHistory" */ './view/quiz-contest-dashboard/index.vue'),
        //   beforeEnter: (to, from, next) => {
        //     store.dispatch('getQuizContestListFun').then((res) => {
        //       $('.httploader').hide()
        //     }).catch((err) => {})
        //     document.title = 'Oddvega - Contest'
        //     next();
        //   }
        // },
        {
          path: '/contest/',
          name: 'contest',
          component: () => import( /* webpackChunkName: "paymentHistory" */ './view/quiz-contest-dashboard-api/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getQuizContestListFun').then((res) => {
              $('.httploader').hide()
            }).catch((err) => {})
            store.dispatch('getContestPointsObtainedFun')
            store.dispatch('getContestLeaderBoardListFun')
            document.title = 'Oddvega - Contest'
            next();
          }
        },
        {
          path: '/contest/testing/',
          name: 'contestTesting',
          component: () => import( /* webpackChunkName: "paymentHistory" */ './view/quiz-contest-dashboard-api/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getQuizContestForTestingListFun', {id:1}).then((res) => {
              $('.httploader').hide()
            }).catch((err) => {})
            store.dispatch('getContestPointsObtainedFun')
            store.dispatch('getContestLeaderBoardListFun')
            document.title = 'Oddvega - Contest Testing'
            next();
          }
        },
        {
          path: '/contest/quiz/:quizId',
          name: 'contestQuiz',
          component: () => import( /* webpackChunkName: "courseQuiz" */ './view/contestQuiz/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Contest Quiz'
            next();
          }
        },
        {
          path: '/contest/testing/quiz/:quizId',
          name: 'contestTestingQuiz',
          component: () => import( /* webpackChunkName: "courseQuiz" */ './view/contestQuiz/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Contest Quiz'
            next();
          }
        },
      ]
    },
    {
      path: '/interview/list/',
      name: 'interviewContestList',
      component: () => import( /* webpackChunkName: "interviewContestList" */ './view/interview/contest-list/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Interview'
        next();
      }
    },
    {
      path: '/interview/:contestId',
      name: 'interviewContestDashboard',
      component: () => import( /* webpackChunkName: "interviewContestDashboard" */ './view/interview/contest-info-page/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Interview'
        next();
      }
    },
  ]
})

// Routes use for without login. these are the name of routes not path
const openRoutes = ['home', 'login', 'signup', 'testimonials', 'course-category', 'coursedescription',  'userVerified', 'passwordReset', 'forgotPassword', 'media', 'mediaDetails', 'PrivacyPolicy', 'termsOfCondition', 'ContactUs', 'AboutUs', 'userAgreement', 'interviewContestList', 'interviewContestDashboard']

const BaseUrl = process.env.VUE_APP_URL;
router.beforeEach((to, from, next) => {
  $(window).scrollTop(0);
  if (openRoutes.includes(to.name)) {
    document.getElementsByTagName('meta')["robots"].content = "follow index";
    next()
  } else if (store.getters.isAuthenticated && localStorage.getItem('t') != '' && localStorage.getItem('t') != null) {
    document.getElementsByTagName('meta')["robots"].content = "nofollow noindex";
    next()
  } else {
    let redirectTo = to.path;
    redirectTo = '?redirect=' + redirectTo;
    next('/login' + redirectTo)
  }
  const canocialUrl = `${BaseUrl}`+ to.path;
  document.querySelector("link[rel='canonical']").setAttribute("href", canocialUrl);
})

/** Show loader when moving routes */
router.beforeResolve((to, from, next) => {
  if (to.name) {
    if (openRoutes.includes(to.name)) {
      $('.app-loader.global').show()
    }
    next()
  }
})

/** Hide preloader after each routes */
router.afterEach((to, from) => {
  if (openRoutes.includes(to.name)) {
    $('.app-loader.global').hide()
  }
})

export default router;
